$('.compare-filter').on('change', function () {
    let selectedHandle = $(this).find(':selected').attr('data-handle');
    let dataColumn = $(this).attr('data-column');

    //$(`.product-cell[data-column="${dataColumn}"]`).fadeOut();

    fetch(`/products/${selectedHandle}?view=compare-ajax`).then((response) => response.text())
        .then((responseText) => {
            let domNodes = new DOMParser().parseFromString(responseText, "text/html");
            let mainProductInfo = $(domNodes).find('.product-main-info').html();

            $(`.product-cell[data-column="${dataColumn}"]`).html(mainProductInfo);

            for(let i = 1; i <= 3; i++) {
                /*$(`.feature-cell[data-column="${dataColumn}"]`).fadeOut();
                $(`.specification-cell[data-column="${dataColumn}"]`).fadeOut();*/

                let feature = $(domNodes).find(`.feature-cell[data-feature="${i}"]`).html();
                $(`.feature-cell[data-column="${dataColumn}"][data-feature="${i}"]`).html(feature);

                let specification = $(domNodes).find(`.specification-cell[data-specification="${i}"]`).html();
                $(`.specification-cell[data-column="${dataColumn}"][data-specification="${i}"]`).html(specification);
            }

            /*$(`.feature-cell[data-column="${dataColumn}"]`).fadeIn(500);
            $(`.specification-cell[data-column="${dataColumn}"]`).fadeIn(500);
            $(`.product-cell[data-column="${dataColumn}"]`).fadeIn(500);*/
        });


    $('.compare-filter').each(function (mainIter,mainSelector) {
        if ($(this).attr('data-column') != dataColumn) {
            let currentColumn = $(mainSelector).attr('data-column');
            $(mainSelector).find('option').prop("disabled", false);
            $(mainSelector).find(`option[data-handle=${selectedHandle}]`).prop("disabled", true);

            $('.compare-filter').each(function (iter, selector) {
                if ($(selector).attr('data-column') != dataColumn && $(selector).attr('data-column') != currentColumn) {
                    let activeOptionHandle = $(selector).find(':selected').attr('data-handle');
                    $(mainSelector).find(`option[data-handle=${activeOptionHandle}]`).prop("disabled", true);
                }
            });

        }
    });
});

$(document).ready(function() {
    if ($(window).width() <= 1200) {
        let selectedHandle3 = $('.compare-filter[data-column="3"]').find(':selected').attr('data-handle');
        $('.compare-filter').each(function (iter,selector) {
            $(selector).find(`option[data-handle=${selectedHandle3}]`).prop("disabled", false);
        });
    }
});

$(window).resize(function() {
    if ($(window).width() <= 1200) {

        $('.compare-filter').each(function (iter,selector) {
            $(selector).removeClass('compare-three-columns');

            if (!$(selector).hasClass('compare-two-columns')) {
                let selectedHandle3 = $('.compare-filter[data-column="3"]').find(':selected').attr('data-handle');
                $(selector).find(`option[data-handle=${selectedHandle3}]`).prop("disabled", false);
                $(selector).addClass('compare-two-columns');
            }
        });

    } else {

        $('.compare-filter').each(function (iter,selector) {
            $(selector).removeClass('compare-two-columns');

            if (!$(selector).hasClass('compare-three-columns')) {
                let selectedHandle3 = $('.compare-filter[data-column="3"]').find(':selected').attr('data-handle');
                $(selector).find(`option[data-handle=${selectedHandle3}]`).prop("disabled", true);
                $(selector).addClass('compare-three-columns');
            }
        });
    }
});